module.exports = __webpack_public_path__ + "static/media/lincoln-headset.f2c4d999.svg";